import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-started-content',
  templateUrl: './get-started-content.component.html',
  styleUrls: ['./get-started-content.component.css']
})
export class GetStartedContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
